import { Typography, List, ListItem, ListItemAvatar, Avatar, Stack } from "@mui/material";
import { styled } from "@mui/system";

/**
 * Render read only view of a user
 * @param {*} userDetails 
 * @returns 
 */
 export function UserReadOnly({userDetails}) {

  const LocalStyledList = styled(List)(({theme}) => ({
      display: 'inline-block',
      paddingRight: '2em',
      border: '1px solid #f1f3f5',
      ':hover': {
          background: '#f1f3f5',
          cursor: 'text',
      }
  }));

  return (
    <ListItem alignItems="flex-start">
      <ListItemAvatar>
          <Avatar alt={userDetails.name} />
      </ListItemAvatar>
          <Stack direction="column">
            <Typography variant="h6">{userDetails.name}</Typography>
            <Typography variant="body2">{userDetails.email}</Typography>
            <Typography variant="body2">{userDetails.phone}</Typography>
            <Typography variant="body2">{userDetails.account?.name || <em>-- no contractor --</em>}</Typography>

            <LocalStyledList>
              {
                (userDetails.roles || []).map((thisRole) => {
                    return (
                        <ListItem dense={true} sx={{px: 1}} key={thisRole}>
                            <Typography variant="body2">{thisRole}</Typography>
                        </ListItem>
                    )
                })
              }
            </LocalStyledList>
          </Stack>

    </ListItem>
  )
}